// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import TextField from '@mui/material/TextField';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from "../../../../../shared-components/WYSIWYGEditor";
import ImageAttribution from '../shared/ImageAttribution';

const Enrichment = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Image" instructions="Describe an image that aligns with the context of this article." />
      <Controller 
        control={control}
        name="content.core.media"
        render={({ field }) => <ImageAttribution targetObj="content.core.media" inputDir={inputDir} errors={errors.content?.core?.media} {...{control }} />}
      />
      
      <NumberedHeading number="2" title="Pre Content" instructions="Enter what ever content must come before the link is presented to the user." />
      <Controller
        control={control}
        name="content.core.text"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.core?.content?.text} />}
      />

      <NumberedHeading number="3" title="Link to Materials" instructions="What is the link to the materials?" />
      <Controller
        control={control}
        name="content.core.link"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="Link to Materials"
            placeholder="Link to Materials"
            error={!!errors.core?.content?.link}
            helperText={errors.core?.content?.link?.message}
            variant="outlined"  
            fullWidth
            multiline
            required
          />
        )}
      />

      <NumberedHeading number="4" title="Post Link" instructions="Enter what ever content must come after thelink is presented to the user." />
      <Controller
        control={control}
        name="content.core.conclusion"
        render={({ field }) => <WYSIWYGEditor {...field} error={errors.core?.content?.conclusion} />}
      />
    </div>
  )
};

export default Enrichment;